import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { useFormContext } from 'react-hook-form';

const EmailField = () => {
	const form = useFormContext();
	return (
		<div className="w-full mb-4">
			<FormField
				control={form.control}
				name="email"
				render={({ field, fieldState }) => (
					<FormItem>
						<FormLabel>Email</FormLabel>
						<FormControl>
							<Input
								placeholder="Email"
								{...field}
								className={
									fieldState.invalid
										? 'border-red '
										: 'border-gray-05 focus-visible:outline-none '
								}
							/>
						</FormControl>
						<FormMessage />
					</FormItem>
				)}
			/>
		</div>
	);
};

export default EmailField;
